import { Skeleton, SkeletonProps } from "@mui/material";
import React, { PropsWithChildren } from "react";

type Props = PropsWithChildren<
  SkeletonProps & {
    loading: boolean;
  }
>;

const SkeletonLoadingComponent: React.FC<Props> = ({
  children,
  loading,
  ...props
}) => {
  return loading ? (
    <Skeleton animation="wave" height="7rem" {...props} />
  ) : (
    <>{children}</>
  );
};

const SkeletonLoading = React.memo(SkeletonLoadingComponent);

export { SkeletonLoading };
